/* Collection filters — mobile sort/filter drawer and desktop auto-submit.

   Ported from prototype/pages/all-products/all-products.js (setupDrawers).
   The drawer open/close, backdrop, Escape-key and sort-selection behaviours are
   preserved. Filters submit through a real form GET, so the "Apply" button
   just submits the form.

   Desktop filters submit on change (progressive enhancement). Mobile filters
   submit through the Apply button inside the drawer form.
*/

(() => {
  if (window.CaratKinCollectionFilters) return;
  window.CaratKinCollectionFilters = true;

  /* ---- Drawer open / close ---------------------------------------------- */

  const drawer = document.querySelector("[data-catalog-drawer]");
  const backdrop = document.querySelector("[data-drawer-backdrop]");
  if (!drawer || !backdrop) return;

  function close() {
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    backdrop.hidden = true;
    document.body.classList.remove("drawer-open");
  }

  document.querySelectorAll("[data-open-drawer]").forEach((button) => {
    button.addEventListener("click", () => {
      const type = button.dataset.openDrawer;
      const title = document.querySelector("[data-drawer-title]");
      if (title) title.textContent = type === "sort" ? "Sort By" : "Filters";
      // "Clear All" belongs to the filter sheet only.
      const clear = document.querySelector("[data-drawer-clear]");
      if (clear) clear.hidden = type === "sort";

      document.querySelectorAll("[data-drawer-content]").forEach((content) => {
        content.hidden = content.dataset.drawerContent !== type;
      });

      backdrop.hidden = false;
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      document.body.classList.add("drawer-open");
    });
  });

  document.querySelectorAll("[data-close-drawer]").forEach((button) => {
    button.addEventListener("click", close);
  });

  backdrop.addEventListener("click", close);

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") close();
  });

  /* ---- Sort selection (mobile) ----------------------------------------- */

  document.querySelectorAll("[data-sort-option]").forEach((radio) => {
    radio.addEventListener("change", () => {
      // Update hidden sort input in the mobile filter form
      const hidden = document.querySelector("[data-mobile-sort-hidden]");
      if (hidden) hidden.value = radio.value;

      // Also update the desktop form's hidden sort input
      const desktopForm = document.getElementById("CollectionFiltersForm");
      if (desktopForm) {
        let desktopSort = desktopForm.querySelector('input[name="sort_by"]');
        if (!desktopSort) {
          desktopSort = document.createElement("input");
          desktopSort.type = "hidden";
          desktopSort.name = "sort_by";
          desktopForm.prepend(desktopSort);
        }
        desktopSort.value = radio.value;
      }

      // Navigate immediately on sort change
      // "Featured" is the collection's default order: drop the parameter.
      const url = new URL(window.location.href);
      if (radio.hasAttribute("data-sort-default")) url.searchParams.delete("sort_by");
      else url.searchParams.set("sort_by", radio.value);
      window.location.href = url.toString();
    });
  });

  /* ---- Mobile filter form ------------------------------------------------
     Stone type and Style are product tags, which narrow a collection through
     its path (/collections/rings/diamond+solitaire); availability and price
     are ?filter params. Build that URL on Apply. Price bands become the
     price filter's gte/lte. Tapping a chosen chip again clears it. */

  const mobileForm = document.querySelector("[data-mobile-filters]");
  if (mobileForm) {
    mobileForm.querySelectorAll('input[type="radio"]').forEach((radio) => {
      let wasChecked = false;
      radio.addEventListener("pointerdown", () => { wasChecked = radio.checked; });
      radio.closest("label")?.addEventListener("pointerdown", () => { wasChecked = radio.checked; });
      radio.addEventListener("click", () => {
        if (wasChecked) radio.checked = false;
        wasChecked = false;
      });
    });

    mobileForm.addEventListener("submit", (event) => {
      event.preventDefault();
      const base = mobileForm.dataset.collectionUrl || window.location.pathname;
      const params = new URLSearchParams();

      const sort = mobileForm.querySelector('input[name="sort_by"]')?.value;
      if (sort) params.set("sort_by", sort);

      mobileForm.querySelectorAll('input[type="checkbox"]:checked').forEach((box) => {
        params.append(box.name, box.value);
      });

      const band = mobileForm.querySelector("[data-price-band]:checked");
      if (band) {
        const [min, max] = band.value.split("-");
        if (min) params.set("filter.v.price.gte", min);
        if (max) params.set("filter.v.price.lte", max);
      }

      const tags = [...mobileForm.querySelectorAll("[data-tag-choice]:checked")].map((input) => input.value);
      const path = tags.length ? `${base}/${tags.join("+")}` : base;
      const query = params.toString();
      window.location.href = query ? `${path}?${query}` : path;
    });
  }

  /* ---- Desktop auto-submit on filter change ----------------------------- */

  const desktopForm = document.getElementById("CollectionFiltersForm");
  if (desktopForm) {
    desktopForm.addEventListener("change", () => {
      desktopForm.submit();
    });
  }
})();
